export function getPlaceholder(field) {
    // If show label is false, don't display the placeholder
    if (field.settings?.showLabel === 'False') {
        return undefined;
    }
    // If settings includes placeholder, display the placeholder
    if (field.settings?.placeholder) {
        return field.settings?.placeholder;
    }
    // If settings includes select prompt, display the select prompt as the placeholder
    if (field.settings?.selectPrompt) {
        return field.settings?.selectPrompt;
    }
    // Display default placeholder
    if (field.placeholder) {
        return field.placeholder;
    }
    return undefined;
}
